import { render } from "./BuyBox.vue?vue&type=template&id=0c3f93b4"
import script from "./BuyBox.vue?vue&type=script&lang=js"
export * from "./BuyBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ZyMall/components/single/BuyBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c3f93b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c3f93b4', __exports__)) {
    api.reload('0c3f93b4', __exports__)
  }
  
  module.hot.accept("./BuyBox.vue?vue&type=template&id=0c3f93b4", () => {
    api.rerender('0c3f93b4', render)
  })

}


export default __exports__